export const environment = {
  production: true,
  CI_COMMIT_SHA: process.env.CI_COMMIT_SHA,
  FULTONGRACE_URL: 'https://preview.fultongrace.com',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_miGT6wnwJCyd9Rf3Nnq1uNeR',
  DOMAIN: 'preview.fultongrace.com',
  ENV_NAME: 'preview',
  PAYLOAD_ORG_ID: 'acct_3dz1KCofB6sQ8P76sydN8',
};
